const VIZA_MAP_STYLES = [
  {
    elementType: 'geometry',
    stylers: [{ color: '#edf4f1' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#5f6f69' }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#f8fbfa' }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#c8d8d2' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{ color: '#e8f2ee' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#dcece5' }],
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#d2e9df' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#dfe9e5' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#cce6dc' }],
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#c8e1d8' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#52776b' }],
  },
];

let contactMapInitialized = false;

export default function initContactMap() {
  const mapModule = document.querySelector('[data-contact-map]');

  if (contactMapInitialized || !mapModule || !window.google || !window.google.maps) {
    return;
  }

  const canvas = mapModule.querySelector('.contact-map__canvas');
  const latitude = Number.parseFloat(mapModule.dataset.latitude);
  const longitude = Number.parseFloat(mapModule.dataset.longitude);
  const zoom = Number.parseInt(mapModule.dataset.zoom, 10);

  if (!canvas || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return;
  }

  contactMapInitialized = true;

  const position = { lat: latitude, lng: longitude };
  const map = new window.google.maps.Map(canvas, {
    center: position,
    zoom: Number.isFinite(zoom) ? zoom : 15,
    styles: VIZA_MAP_STYLES,
    backgroundColor: '#edf4f1',
    clickableIcons: false,
    fullscreenControl: true,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    gestureHandling: 'cooperative',
  });

  new window.google.maps.Marker({
    map,
    position,
    title: mapModule.dataset.address || 'Viza.az',
    icon: {
      path: window.google.maps.SymbolPath.CIRCLE,
      fillColor: '#00bd84',
      fillOpacity: 1,
      scale: 9,
      strokeColor: '#ffffff',
      strokeWeight: 4,
    },
  });

  window.google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
    mapModule.classList.add('is-map-ready');
  });
}
